<template>
  <div class="
        uk-flex-center
        uk-child-width-1-2
        uk-child-width-1-4@m
      " uk-grid>
    <TypeButton v-for="button in buttons"
                :key="button.title"
                :active="button.active || false"
                ref="typeButton"
                :type="button.type"
                @click="changeActiveOne"
    >{{ button.title }}
    </TypeButton>
  </div>
</template>

<script>
import TypeButton from '@/components/TypeButton.vue';

export default {
  name: 'ButtonSelector.vue',
  components: { TypeButton },
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
  methods: {
    changeActiveOne(btn) {
      this.$refs.typeButton.forEach((button, index) => {
        this.$refs.typeButton[index].isActive = false;
      });

      // eslint-ignore no-param-reassign
      btn.isActive = true;
      this.$emit('change', btn);
    },
  },
};
</script>
